import React from 'react';

import {
  Content,
  Highlight,
  IconSlot,
  InfoBoxSize,
  StyledInfoBox,
} from './styles';

export type InfoBoxProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: InfoBoxSize;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  icon?: React.ReactNode;
  highlight?: React.ReactNode;
};

const InfoBox = ({
  size = 'md',
  color,
  backgroundColor,
  borderColor,
  icon,
  highlight,
  children,
  ...rest
}: InfoBoxProps): JSX.Element => {
  return (
    <StyledInfoBox
      $size={size}
      $color={color}
      $backgroundColor={backgroundColor}
      $borderColor={borderColor}
      {...rest}
    >
      {icon && <IconSlot>{icon}</IconSlot>}
      <Content>
        {children}
        {highlight !== undefined && <> <Highlight>{highlight}</Highlight></>}
      </Content>
    </StyledInfoBox>
  );
};

export default InfoBox;
